<template>
  <div class="fotter-toolbar">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SpGlobalFooter'
}
</script>

<style scoped lang="scss">
.fotter-toolbar {
  position: fixed;
  bottom: 0;
  right: 0;
  background: #fff;
  left: 264px;
  padding: 10px;
  box-shadow: 0px 0px 4px 0px rgba(0, 21, 41, 0.12);
  text-align: center;
  z-index: 100;
}
</style>
